import { Accordion, AccordionTab } from '@lmig/lmds-react-accordion';
import { Link } from '@lmig/lmds-react-link';
import { IAIPortalCitation } from 'Feature/Coveo/Helpers/AIAnswerApi';
import { isSafeAnswerLink } from './AIAnswerContent';

interface ICitationLinksProps {
  citations: IAIPortalCitation[];
}

export function CitationLinks({ citations }: ICitationLinksProps) {
  const validCitations = citations.filter(
    (citation) => citation.title.trim() && citation.url.trim() && isSafeAnswerLink(citation.url),
  );

  if (validCitations.length === 0) return null;
  const sourcesLabel = `Sources (${validCitations.length})`;

  const links = (
    <ul className="ai-summary-citations-links">
      {validCitations.map((citation, index) => (
        <li key={`${index}-${citation.id ?? citation.url}`}>
          <Link variant="inline" href={citation.url.trim()} target="_blank" rel="noopener noreferrer">
            {citation.title.trim()}
          </Link>
        </li>
      ))}
    </ul>
  );

  return validCitations.length > 3 ? (
    <Accordion className="ai-summary-citations-accordion" as="h3" variant="list">
      <AccordionTab labelVisual={sourcesLabel}>{links}</AccordionTab>
    </Accordion>
  ) : (
    <div className="ai-summary-citations-div-no-accordion">
      <h3 className="ai-summary-citations-header">{sourcesLabel}</h3>
      {links}
    </div>
  );
}
